import { render, staticRenderFns } from "./systemPreferences.vue?vue&type=template&id=bb3783a6&scoped=true"
import script from "./systemPreferences.vue?vue&type=script&lang=js"
export * from "./systemPreferences.vue?vue&type=script&lang=js"
import style0 from "./systemPreferences.vue?vue&type=style&index=0&id=bb3783a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3783a6",
  null
  
)

export default component.exports